import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_b297b84f-8b46-4abc-98df-e6e57ca92e5d/artifacts/e164a4fcdbe7c154_image.png";

const api = axios.create({ baseURL: API });

const storedToken = typeof localStorage !== "undefined" ? localStorage.getItem("nl_token") : null;
if (storedToken) api.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;

export const setAuthToken = (t) => {
  if (t) {
    localStorage.setItem("nl_token", t);
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  } else {
    localStorage.removeItem("nl_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export const authLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const listUsers = () => api.get("/admin/users").then((r) => r.data);
export const createUser = (d) => api.post("/admin/users", d).then((r) => r.data);
export const deleteUser = (id) => api.delete(`/admin/users/${id}`).then((r) => r.data);

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getArticles = (params = {}) => api.get("/articles", { params }).then((r) => r.data);
export const getArticle = (slug) => api.get(`/articles/${slug}`).then((r) => r.data);
export const getGalleries = () => api.get("/galleries").then((r) => r.data);
export const getGallery = (slug) => api.get(`/galleries/${slug}`).then((r) => r.data);
export const getBusinesses = (category) =>
  api.get("/businesses", { params: category ? { category } : {} }).then((r) => r.data);
export const submitBusiness = (data) => api.post("/businesses", data).then((r) => r.data);
export const getSocialPosts = () => api.get("/social-posts").then((r) => r.data);
export const getAds = (slot) => api.get("/ads", { params: slot ? { slot } : {} }).then((r) => r.data);
export const getPlans = () => api.get("/plans").then((r) => r.data);
export const subscribeNewsletter = (data) => api.post("/newsletter", data).then((r) => r.data);
export const createCheckout = (lookup_key) =>
  api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

// ---- Admin / CMS ----
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminArticles = () => api.get("/admin/articles").then((r) => r.data);
export const adminCreateArticle = (d) => api.post("/admin/articles", d).then((r) => r.data);
export const adminUpdateArticle = (id, d) => api.put(`/admin/articles/${id}`, d).then((r) => r.data);
export const adminDeleteArticle = (id) => api.delete(`/admin/articles/${id}`).then((r) => r.data);
export const adminCreateGallery = (d) => api.post("/admin/galleries", d).then((r) => r.data);
export const adminDeleteGallery = (id) => api.delete(`/admin/galleries/${id}`).then((r) => r.data);
export const adminBusinesses = () => api.get("/admin/businesses").then((r) => r.data);
export const adminCreateBusiness = (d) => api.post("/admin/businesses", d).then((r) => r.data);
export const adminUpdateBusiness = (id, d) => api.put(`/admin/businesses/${id}`, d).then((r) => r.data);
export const adminDeleteBusiness = (id) => api.delete(`/admin/businesses/${id}`).then((r) => r.data);
export const adminSubs = () => api.get("/admin/business-submissions").then((r) => r.data);
export const adminApproveSub = (id) => api.post(`/admin/business-submissions/${id}/approve`).then((r) => r.data);
export const adminDeleteSub = (id) => api.delete(`/admin/business-submissions/${id}`).then((r) => r.data);
export const adminCreateAd = (d) => api.post("/admin/ads", d).then((r) => r.data);
export const adminUpdateAd = (id, d) => api.put(`/admin/ads/${id}`, d).then((r) => r.data);
export const adminDeleteAd = (id) => api.delete(`/admin/ads/${id}`).then((r) => r.data);
export const adminCreateSocial = (d) => api.post("/admin/social-posts", d).then((r) => r.data);
export const adminDeleteSocial = (id) => api.delete(`/admin/social-posts/${id}`).then((r) => r.data);

// ---- Extended platform ----
export const getPets = (species) => api.get("/pets", { params: species && species !== "All" ? { species } : {} }).then((r) => r.data);
export const getFeaturedPet = () => api.get("/pets/featured").then((r) => r.data);
export const getRescues = () => api.get("/rescues").then((r) => r.data);
export const adminCreatePet = (d) => api.post("/admin/pets", d).then((r) => r.data);
export const adminFeaturePet = (id) => api.post(`/admin/pets/${id}/feature`).then((r) => r.data);
export const adminDeletePet = (id) => api.delete(`/admin/pets/${id}`).then((r) => r.data);
export const getEditions = () => api.get("/editions").then((r) => r.data);
export const getEdition = (id) => api.get(`/editions/${id}`).then((r) => r.data);
export const adminCreateEdition = (d) => api.post("/admin/editions", d).then((r) => r.data);
export const adminDeleteEdition = (id) => api.delete(`/admin/editions/${id}`).then((r) => r.data);
export const getClassifieds = (category) => api.get("/classifieds", { params: category && category !== "All" ? { category } : {} }).then((r) => r.data);
export const submitClassified = (d) => api.post("/classifieds", d).then((r) => r.data);
export const adminClassifieds = () => api.get("/admin/classifieds").then((r) => r.data);
export const adminDeleteClassified = (id) => api.delete(`/admin/classifieds/${id}`).then((r) => r.data);
export const getCoastalConditions = () => api.get("/coastal-conditions").then((r) => r.data);
export const getHeaderPhotoToday = () => api.get("/header-photos/today").then((r) => r.data);
export const getHeaderPhotos = () => api.get("/header-photos").then((r) => r.data);
export const submitHeaderPhoto = (d) => api.post("/header-photos", d).then((r) => r.data);
export const adminHeaderPhotos = () => api.get("/admin/header-photos").then((r) => r.data);
export const adminCreateHeaderPhoto = (d) => api.post("/admin/header-photos", d).then((r) => r.data);
export const adminApproveHeaderPhoto = (id) => api.post(`/admin/header-photos/${id}/approve`).then((r) => r.data);
export const adminDeleteHeaderPhoto = (id) => api.delete(`/admin/header-photos/${id}`).then((r) => r.data);
export const adminLoyaltyOffers = () => api.get("/admin/loyalty/offers").then((r) => r.data);
export const adminCreateOffer = (d) => api.post("/admin/loyalty/offers", d).then((r) => r.data);
export const adminUpdateOffer = (id, d) => api.put(`/admin/loyalty/offers/${id}`, d).then((r) => r.data);
export const adminDeleteOffer = (id) => api.delete(`/admin/loyalty/offers/${id}`).then((r) => r.data);
export const adminLoyaltyMembers = () => api.get("/admin/loyalty/members").then((r) => r.data);
export const adminToggleMemberSubscriber = (id) => api.post(`/admin/loyalty/members/${id}/subscriber`).then((r) => r.data);
export const adminImportSubscribers = (emails) => api.post("/admin/loyalty/subscribers", { emails, source: "print" }).then((r) => r.data);
export const adminLoyaltyClaims = () => api.get("/admin/loyalty/claims").then((r) => r.data);
export const getDailyDeal = () => api.get("/daily-deal").then((r) => r.data);
export const adminDeals = () => api.get("/admin/daily-deals").then((r) => r.data);
export const adminCreateDeal = (d) => api.post("/admin/daily-deals", d).then((r) => r.data);
export const adminDeleteDeal = (id) => api.delete(`/admin/daily-deals/${id}`).then((r) => r.data);
export const getContests = () => api.get("/contests").then((r) => r.data);
export const enterContest = (id, d) => api.post(`/contests/${id}/enter`, d).then((r) => r.data);
export const adminContests = () => api.get("/admin/contests").then((r) => r.data);
export const adminCreateContest = (d) => api.post("/admin/contests", d).then((r) => r.data);
export const adminContestEntries = (id) => api.get(`/admin/contests/${id}/entries`).then((r) => r.data);
export const adminDeleteContest = (id) => api.delete(`/admin/contests/${id}`).then((r) => r.data);
export const aiDraft = (d) => api.post("/admin/ai/draft", d).then((r) => r.data);

// ---- Section Sponsors ----
export const getSectionSponsors = () => api.get("/section-sponsors").then((r) => r.data);
export const adminSectionSponsors = () => api.get("/admin/section-sponsors").then((r) => r.data);
export const adminUpsertSectionSponsor = (section, d) => api.put(`/admin/section-sponsors/${section}`, d).then((r) => r.data);
export const adminDeleteSectionSponsor = (section) => api.delete(`/admin/section-sponsors/${section}`).then((r) => r.data);

// ---- Events ----
export const getEvents = (month) => api.get("/events", { params: month ? { month } : {} }).then((r) => r.data);
export const submitEvent = (d) => api.post("/events", d).then((r) => r.data);
export const eventSponsorCheckout = (id) => api.post(`/events/${id}/sponsor-checkout`, { origin_url: window.location.origin }).then((r) => r.data);
export const adminEvents = () => api.get("/admin/events").then((r) => r.data);
export const adminCreateEvent = (d) => api.post("/admin/events", d).then((r) => r.data);
export const adminUpdateEvent = (id, d) => api.put(`/admin/events/${id}`, d).then((r) => r.data);
export const adminApproveEvent = (id) => api.post(`/admin/events/${id}/approve`).then((r) => r.data);
export const adminToggleSponsorEvent = (id) => api.post(`/admin/events/${id}/sponsor`).then((r) => r.data);
export const adminDeleteEvent = (id) => api.delete(`/admin/events/${id}`).then((r) => r.data);

// ---- Community Voices & Scoreboard ----
export const getCommunity = (kind) => api.get("/community", { params: kind ? { kind } : {} }).then((r) => r.data);
export const getCommunityPost = (id) => api.get(`/community/${id}`).then((r) => r.data);
export const submitMyPost = (d) => api.post("/admin/my-posts", d).then((r) => r.data);
export const myPosts = () => api.get("/admin/my-posts").then((r) => r.data);
export const adminCommunityPosts = (status) => api.get("/admin/community-posts", { params: status ? { status } : {} }).then((r) => r.data);
export const adminApprovePost = (id) => api.post(`/admin/community-posts/${id}/approve`).then((r) => r.data);
export const adminDeletePost = (id) => api.delete(`/admin/community-posts/${id}`).then((r) => r.data);

export default api;
